import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Row, Col, Tooltip } from 'core/components/ui'
import { greys } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const RenderColor = styled(Row)`
  background-color: ${props => props.color};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  border: 1px solid ${greys.light3};
  box-shadow: 1px 1px 10px ${greys.dark3};
  transition: all 500ms;
  &.activ {
    border-color: ${props => props.theme.colors.color1.bg};
    border-width: 5px;
    box-shadow: none;
  }
`

/************* */

const Color = props => {
  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { externalColorsReference } = filters
  const externalColorsReferenceList = filtersDatas.externalColorsReference

  const handleClick = item => {
    const isSelected = !externalColorsReference
      ? false
      : externalColorsReference.filter(el => el === item.value).length > 0

    let extendedColorsValues = externalColorsReference ? [...externalColorsReference] : []

    if (!isSelected) {
      extendedColorsValues.push(item.value)
    } else {
      extendedColorsValues = externalColorsReference.filter(el => el !== item.value)
    }

    const extendedFiltersValues = {
      ...filters,
      externalColorsReference: extendedColorsValues
    }

    onChangeFilter(extendedFiltersValues)
  }

  const renderItem = item => {
    const { label, value } = item

    const isSelected = !externalColorsReference
      ? false
      : externalColorsReference.filter(el => el === value).length > 0

    return (
      <Col
        key={label}
        span={6}
        onClick={() => handleClick(item)}
        data-test="stock-vehicles-list-filters-color-FilterItemWrapper"
      >
        <Tooltip title={label} data-test="stock-vehicles-list-filters-color-tooltip">
          <RenderColor
            color={value}
            type="flex"
            align="middle"
            justify="center"
            className={isSelected ? 'activ' : ''}
            data-test="stock-vehicles-list-filters-color-renderColor"
          />
        </Tooltip>
      </Col>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-color">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-color-title'
        })}
        data-test="stock-vehicles-list-filters-color-title"
      />
      <Row type="flex" gutter={30}>
        {externalColorsReferenceList && externalColorsReferenceList.map(item => renderItem(item))}
      </Row>
    </div>
  )
}

Color.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(Color)
